import { Directive, ElementRef, input } from '@angular/core';

import type {
  RtAddNewButtonVariant,
  RtButtonColorContextVariant,
  RtButtonVariant,
  RtButtonSize,
  RtIconButtonVariant,
  RtInfoboxButtonVariant,
  RtPlanButtonVariant,
  RtWalkthroughButtonVariant,
} from './button.types';

@Directive({
  standalone: true,
  selector: 'rt-button-base',
  host: {
    '[class]': '"rt-button " + size() + " " + variant()',
    '[class.disabled]': 'disabled() === true',
    '[class.active]': 'active() === true',
    '[class.pressed]': 'pressed() === true',
    '(click)': 'onClick($event)',
  },
})
export abstract class BaseButtonDirective {
  public readonly size = input<Extract<RtButtonSize, 'small' | 'medium' | 'small-x'>>('medium');
  public readonly variant = input<
    | RtButtonVariant
    | RtPlanButtonVariant
    | RtIconButtonVariant
    | RtAddNewButtonVariant
    | RtInfoboxButtonVariant
    | RtWalkthroughButtonVariant
    | RtButtonColorContextVariant
  >(undefined!);
  public readonly disabled = input<boolean>(false);
  public readonly active = input<boolean>(false);
  public readonly pressed = input<boolean>(false);

  constructor(public elRef: ElementRef) {}

  public onClick(event: Event) {
    if (!this.disabled()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }
}
